import { motion } from "framer-motion";
import Banner from "../components/Banner";
import Footer from "../components/Footer";

const PrivacyStatement = () => {
  return (
    <>
      <motion.div
        className="legal-container"
        initial={{ opacity: 0, z: 100 }}
        animate={{ opacity: 1, z: 0 }}
        exit={{ opacity: 0, z: -100 }}
        transition={{ duration: 1, delay: 0.75 }}
      >
        <div className="legal-header">
          <Banner text="Privacy" />
        </div>
        <div className="legal-section">
          <div className="legal-section-left">
            <h2>Your personal information</h2>
          </div>
          <div className="legal-section-right">
            <p>
              Some personal information is required. This information is never
              shared with any third parties and is only used to provide the best
              possible service.
            </p>
          </div>
        </div>
        <div className="legal-section">
          <div className="legal-section-left">
            <h2>What personal information is collected</h2>
          </div>
          <div className="legal-section-right">
            <p>
              When you use the Contact form, your name and email address are
              collected, as well as any information you choose to include in the
              message. Your location is also collected for reasons mentioned
              below in the "Cookie Policy".
            </p>
          </div>
        </div>
        <div className="legal-section">
          <div className="legal-section-left">
            <h2>How your information is used</h2>
          </div>
          <div className="legal-section-right">
            <p>
              Your information is used to respond to your message, and from time
              to time, your information may be used to send important notices.
              Such as changes to the Privacy Policy.
            </p>
          </div>
        </div>
        <div className="legal-section">
          <div className="legal-section-left">
            <h2>Cookie policy</h2>
          </div>
          <div className="legal-section-right">
            <p>
              Cookies are small size files sent by the website, which are saved
              on website visitors device. Cookies help website to identity the
              visitor and keep track of their interactions for later use, i.e.
              setting language preference. Cookies are used in most websites, in
              detail this mechanic is defined in RFC6265.
              <br />
              Cookies are used in this website to to monitor site traffic only.
              For this, Google Analytics is used. You can read more about their
              privacy and terms of use from their website. Your personal
              information is not collected by this website.
              <br />
              Opting-out of 3rd party cookies is possible by using the Google
              Analytics Opt-out Browser Add-on.
            </p>
          </div>
        </div>
      </motion.div>
      <motion.div
        className="page-bottom-sections"
        initial={{
          opacity: 0.75,
          clipPath: "polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)",
        }}
        whileInView={{
          opacity: 1,
          clipPath: "polygon(0% 100%, 100% 100%, 100% 0%, 0% 0%)",
        }}
        transition={{ duration: 0.5 }}
      >
        <Footer />
      </motion.div>
    </>
  );
};

export default PrivacyStatement;
